function updateClipPath() {
	const rows = document.querySelectorAll('.block-cta-standard__row');
	rows.forEach((row) => {
		const height = row.offsetHeight;
		let clipPath;
		let y296, y399, y396;

		// if (window.innerWidth < 768) {
		// 	// Mobile breakpoint
		// 	y296 = height * 0.4; // Adjust as needed for mobile
		// 	y399 = height * 0.89;
		// 	y396 = height * 0.88;
		// 	clipPath = `polygon(0px 0px, 100% 0px, 100% 90%, 80% 100%, 0px 100%, 0px 0px)`;
		// } else {
		// 	y296 = height * 0.75; // Adjust as needed for desktop
		// 	y399 = height * 0.99;
		// 	y396 = height * 0.98;
		// 	clipPath = `polygon(0 0, 100% 0, 100% ${y296}px, 92% ${y399}px, 0 ${y396}px, 0 0)`;
		// }

		row.style.clipPath = clipPath;
	});
}

window.addEventListener('DOMContentLoaded', updateClipPath);
window.addEventListener('resize', updateClipPath);
